/**
 * Escapes special characters in a string so it can be safely used in a regex pattern.
 */
export function escapeRegex(input?: string): string {
  return input?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') ?? '';
}

/**
 * Validates if the given input is safe for manuscriptId partial search.
 *
 * Allowed characters:
 *   - Letters (a–z, A–Z)
 *   - Digits (0–9)
 *   - Hyphen (-)
 *   - Dot (.)
 *
 * Disallowed:
 *   - Any other special characters (e.g., $, *, +, |, \, space, etc.)
 *   - Empty or null strings
 */
export function isValidManuscriptIdSearch(
  search: string | null | undefined
): boolean {
  if (!search) return false;

  const trimmed = search.trim();
  if (!trimmed) return false;

  // Only allow letters, digits, dash, and dot
  const validPattern = /^[a-zA-Z0-9.-]+$/;
  if (!validPattern.test(trimmed)) return false;

  // Disallow more than one dot
  const dotCount = (trimmed.match(/\./g) || []).length;
  if (dotCount > 1) return false;

  return true;
}

export function searchTitleRegex(input: string): string {
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const PHONE_NUMBER_REGEX =
  '^(?=(?:\\D*\\d){3,15}\\D*$)\\+?(?:\\d+|\\(\\d+\\))(?:[ \\-()]?(?:\\d+|\\(\\d+\\)))*$';

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+=\-[\]{};:'"\\|,.<>/?~`]{8,}$/;
